import React from 'react';
import ConfirmationModal, { BoldText } from '../../ConfirmationModal';
import { CALL_LIST } from '../../../support/cypressTags';

const DeleteModal = ({ isOpen, onCancel, onConfirm, impactedCount }) => (
  <ConfirmationModal
    isOpen={isOpen}
    onCancel={onCancel}
    onConfirm={onConfirm}
    title="Delete Confirmation"
    confirmCyTag={CALL_LIST.BULK_DELETE_CONFIRMATION}
  >
    Delete <BoldText>{impactedCount}</BoldText> record{impactedCount > 1 ? 's' : ''}?
  </ConfirmationModal>
);

export default DeleteModal;
